import gql from 'graphql-tag';

import { AlbumFolderLinkRequestDetails } from './picture-day';

export const ActionableItemFields = gql`
  fragment ActionableItemFields on IActionableItem {
    ... on IActionableItem {
      item_type
    }

    ... on ActionableAlbumFolderLinkRequestItem {
      created_at
      item_type
      album_folder_link_request {
        ...AlbumFolderLinkRequestDetails
      }
    }

    ... on ActionableReviewPhotoUploadItem {
      album {
        id
        name
      }
      count
      created_at
    }
    ... on ActionableReviewPhotoReportItem {
      album {
        id
        name
      }
      count
      created_at
    }
    ... on ActionablePendingPurchasedCustomPrintItem {
      album {
        id
        name
        root_album_folder {
          id
          name
        }
      }
      count
      created_at
    }
  }
  ${AlbumFolderLinkRequestDetails}
`;
